import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { browserName, browserVersion } from "react-device-detect";
import aplLogoTransparent from "../../i/apl-logo-transparent.png";
import imgLogo from "../../i/ag-logo.png";
import Footer from "./Footerj";
import { getUserConfigRedux } from "../../redux/slices/auth.feature";
import { IRootState } from "../../types/redux/IRootStore";
import { getExceptionText } from "../../translations/gridTranslationHelper";

export const LoginTemplate = () => {
    const [formObj, setFormObj] = useState({ username: "", password: "", sessionDescription: "", persist: false });
    const authRedux = useSelector((state: IRootState) => state.auth);
    let dispatch = useDispatch();

    const handleSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        let cred = {
            username: formObj.username,
            password: formObj.password,
            sessionDescription: `${browserName}-${browserVersion}`,
            persist: formObj.persist
        };
        dispatch(getUserConfigRedux(cred) as any);
    };

    return (
        <React.Fragment>
            <div className="pageOuter">
                <div className="header">
                    <div className="title">
                        <img src={aplLogoTransparent} alt="APL Logo" height="36px" />
                    </div>

                    <div style={{ float: "right" }}>
                        <img id="imgLogo" alt="Ardagh Logo" src={imgLogo} height="36px" style={{ marginBottom: "5px" }} />
                    </div>

                    <div className="clearAll"></div>
                </div>

                <div className="page">
                    <div className="tab-filler">&nbsp;</div>

                    <div className="main" id="MainDiv" style={{ minHeight: "75vh" }}>
                        <div className="container">
                            <div className="container">
                                <div className="row justify-content-center align-items-center" style={{ height: "66vh" }}>
                                    <div className="col-6">
                                        <div className="card bg-light">
                                            <form onSubmit={handleSubmit}>
                                                <div className="card-body">
                                                    <div className="form-group">
                                                        <input
                                                            name="ctl00$MainContent$MainContent_Login1_UserName"
                                                            type="text"
                                                            id="MainContent_Login1_UserName"
                                                            className={`form-control ${authRedux.error ? "is-invalid" : ""}`}
                                                            placeholder="User"
                                                            value={formObj.username}
                                                            onChange={e =>
                                                                setFormObj({
                                                                    ...formObj,
                                                                    username: e.currentTarget.value
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            name="ctl00$MainContent$MainContent_Login1_Password"
                                                            type="password"
                                                            id="MainContent_Login1_Password"
                                                            className={`form-control ${authRedux.error ? "is-invalid" : ""}`}
                                                            placeholder="Passsword"
                                                            value={formObj.password}
                                                            onChange={e =>
                                                                setFormObj({
                                                                    ...formObj,
                                                                    password: e.currentTarget.value
                                                                })
                                                            }
                                                        />
                                                        <div id="validationServer04Feedback" className="invalid-feedback">
                                                            {getExceptionText(authRedux.error, "en-GB")}
                                                        </div>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            name="ctl00$MainContent$MainContent_Login1_Remember"
                                                            type="checkbox"
                                                            id="MainContent_Login1_Remember"
                                                            className="form-check-input"
                                                            // checked={formObj.keepLoggedIn}
                                                            // checked={true}
                                                            // readOnly={true}
                                                            onChange={e =>
                                                                setFormObj({
                                                                    ...formObj,
                                                                    persist: e.currentTarget.checked
                                                                })
                                                            }
                                                            checked={formObj.persist}
                                                        />
                                                        <label className="form-check-label" htmlFor="MainContent_Login1_Remember">
                                                            Remember me
                                                        </label>
                                                    </div>

                                                    <div className="mb-4">
                                                        <input
                                                            type="submit"
                                                            name="ctl00$MainContent$sendlogin"
                                                            value="Login"
                                                            id="MainContent_sendlogin"
                                                            className="btn btn-primary float-right"
                                                        />
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-center align-items-center">
                                    <div className="col-6">
                                        <div className="card mb-3">
                                            <div className="card-body text-center">
                                                <span id="lblHelpdesk1">
                                                    Please contact&nbsp;
                                                    <a href="mailto:helpdesk@ardaghgroup.com">helpdesk@ardaghgroup.com</a>
                                                    &nbsp;for new accounts
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br />
                    </div>
                    <div className="clear"></div>

                    <Footer />
                </div>
            </div>
        </React.Fragment>
    );
};

export default LoginTemplate;
